@if (isVisible()) {
  @if (config(); as config) {
    <div class="global-notifications-banner">
      <div class="banner-inner">
        <div class="banner-left ms-md-5">
          <i class="material-icons maintenance-icon" aria-hidden="true">build_circle</i>
          <span class="banner-message">{{ config.shortText }}</span>
          <span class="banner-datetime">{{ formattedPatchDateTime() }}</span>
        </div>
        @if (config.serviceDeskLink) {
          <div class="banner-right">
            <a [href]="config.serviceDeskLink" target="_blank" rel="noopener noreferrer" class="a-text-link d-flex align-items-center gap-1 banner-service-link">
              <mat-icon class="banner-link-icon">open_in_new</mat-icon>
              {{ 'admin.global-notifications-config.service-desk-link' | translate }}
            </a>
          </div>
        }
      </div>
    </div>
  }
}
